export default __webpack_public_path__ + "static/media/I_loader.4a358204.gif";